import { StatTableColumn } from "components/StatsTable/StatTableColumn";
import { BdlTimeAttackRecordWithDisplay } from "model/Records old/BdlTimeAttackRecord";

export const getBdlTimeAttackRecordOverviewStatTableColumns = (
  trackNames: (string | undefined)[],
  driverTable: boolean
): StatTableColumn<BdlTimeAttackRecordWithDisplay>[] => {
  return [
    {
      type: "Position",
      sortable: true,
      positionGetter: (arg) => arg.record.position,
    },
    {
      type: "OrgLogoName",
      sortable: true,
      orgIdGetter: (arg) => arg.orgId,
      nameGetter: (arg) => arg.displayName,
      smallerSize: true,
    },
    {
      type: "Number",
      header: "Score",
      sortable: true,
      highlight: true,
      valueGetter: (arg) => arg.record.totalScore,
    },
    ...trackNames.map((name, idx) => {
      if (driverTable) {
        const column: StatTableColumn<BdlTimeAttackRecordWithDisplay> = {
          type: "Number",
          header: name ?? "-",
          sortable: !!name,
          fractionDigits: 0,
          valueGetter: (arg) => arg.record.tracks[idx].rank,
          subTextGetter: (arg) =>
            !!arg.record.tracks[idx].score
              ? arg.record.tracks[idx].score?.toString()
              : undefined,
        };

        return column;
      }

      const column: StatTableColumn<BdlTimeAttackRecordWithDisplay> = {
        type: "Number",
        header: name ?? "-",
        sortable: !!name,
        fractionDigits: 2,
        valueGetter: (arg) => arg.record.tracks[idx].score,
      };
      return column;
    }),
  ];
};
